import React from 'react';

export const CanvasWrapper = React.memo(() => {
	return <canvas className="Esign-output_canvas" id="Esign-output_canvas"></canvas>;
});
